export default __webpack_public_path__ + "static/media/product-1-4.755882ea.jpg";